import { configureStore } from "@reduxjs/toolkit";
import doctorReducer from "./Slice/DoctorSlice";
import getSearchAllReducer from "./Slice/SearchAllSlice";
import specialityReducer from "./Slice/SpecialitySlice";
import doctorSlotReducer from "./Slice/SlotSlice";
import loginReducer from "./Slice/Login";
import userReducer from "./Slice/UserSlice";
import appointmentHistoryReducer from "./Slice/AppointmentHistory";
import upcomingAppointmentsReducer from "./Slice/Upcomming";
import medicalRecordReducer from "./Slice/MedicalRecord";
import billingReducer from "./Slice/BillingSlice";
import specialPackagesReducer from "./Slice/SpecialPackage";

const store = configureStore({
  reducer: {
    doctor: doctorReducer,
    allSearchValue: getSearchAllReducer,
    speciality: specialityReducer,
    slot: doctorSlotReducer,
    login: loginReducer,
    user: userReducer,
    appointmentHistory: appointmentHistoryReducer,
    upcomingAppointments: upcomingAppointmentsReducer,
    record: medicalRecordReducer,
    billing: billingReducer,
    packages: specialPackagesReducer,
  },
});

export default store;
